import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eaa6b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product" }
const _hoisted_2 = { class: "product__image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "product__unknown"
}
const _hoisted_5 = { class: "product__info" }
const _hoisted_6 = { class: "product__name" }
const _hoisted_7 = { class: "product__footer" }
const _hoisted_8 = { class: "product__quantity" }
const _hoisted_9 = { class: "product__price" }

import { formatPrice } from '@/helpers/format'
import { Purchases } from 'package-types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: {
    product: null,
    image: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.image,
            alt: ""
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "?"))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.product.productName), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, "х" + _toDisplayString(__props.product.quantity), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatPrice)(__props.product.price)), 1)
      ])
    ])
  ]))
}
}

})